import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["parent", "child", "toggle"];

  connect() {
  }

  toggle(event) {
    const toggle = event.currentTarget;
    const sectionId = toggle.dataset.accordionSectionId;
    const checked = this.inputChecked(toggle);

    const display = checked ? "table-row" : "none";

    this.groupChildren(sectionId).forEach(c => {
        c.style.display = display;

        const input = c.querySelector('input[type="checkbox"]');
        input.checked = checked;

        this.sendInputEvent(input);
    });
  }

  groupChildren(sectionId) {
    return this.childTargets.filter(c => c.dataset.accordionSectionId == sectionId);
  }

  inputChecked(parent) {
    return parent.checked;
  }

  sendInputEvent(input) {
      const event = new Event('change', {
        bubbles: true,
        cancelable: true
      });

      // Dispatch the event on the controller's element
      input.dispatchEvent(event);
    }
}
